<!-- Título -->
<lib-title [text]="title() | translate" tag="h2"/>

<!-- Subtítulo -->
@if (subtitle()) {
  <p>{{ subtitle() | translate }}</p>
}

<!-- Lista de passos com checkmarks -->
<ul class="steps-list">
  @for (step of steps(); track $index) {
    <li class="step-item">
      <svg class="checkmark" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#00095B"/>
      </svg>
      <lib-safe-html [content]="step | translate" />
    </li>
  }
</ul>

<div class="button-container">
  <lib-button
    [type]="'primary'"
    [id]="'btn-close-modal'"
    [disabled]="false"
    (clickButton)="buttonClick.emit()"
  >
    {{ buttonText() | translate }}
  </lib-button>
</div>
